// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --cell-size: 84px;
  --accent: #222;
  --muted: #9aa1ad;
}

.diagram {
  position: relative;
  padding: 36px 80px 90px 140px; /* space for labels */
  width: calc(var(--cols) * var(--cell-size));
  box-sizing: content-box;
}

/* Outer border */
.frame {
  border: 4px solid #1f2937;
  width: calc(var(--cols) * var(--cell-size));
  height: calc(var(--rows) * var(--cell-size));
  display: grid;
  grid-template-columns: repeat(var(--cols), 1fr);
  grid-template-rows: repeat(var(--rows), 1fr);
}

.cell {
  border-right: 1px dashed #bfc7d1;
  border-bottom: 1px dashed #bfc7d1;
}
.cell:nth-child(6n) {
  border-right: none;
}
.cell:nth-last-child(-n + 6) {
  border-bottom: none;
}

/* Measurement boxes */
.m,
.measure-small {
  border: 1px solid #bfc7d1;
  background: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 4px 8px;
  text-align: center;
}

/* Top measures */
.top-measures {
  position: absolute;
  top: -28px;
  left: 120px;
  display: grid;
  grid-template-columns: repeat(var(--cols), var(--cell-size));
  justify-items: center;
  width: calc(var(--cols) * var(--cell-size));
}

/* Left measures */
.left-measures {
  position: absolute;
  top: 0;
  left: -96px;
  height: calc(var(--rows) * var(--cell-size));
  display: grid;
  grid-template-rows: repeat(var(--rows), var(--cell-size));
  align-items: center;
  justify-items: center;
}
.left-measures .m {
  transform: rotate(-90deg);
  width: 62px;
}

/* Right measures */
.right-measures {
  position: absolute;
  top: 0;
  right: -96px;
  height: calc(var(--rows) * var(--cell-size));
  display: grid;
  grid-template-rows: repeat(var(--rows), var(--cell-size));
  align-items: center;
  justify-items: center;
}
.right-measures .m {
  transform: rotate(90deg);
  width: 62px;
}

/* Row labels with connectors */
.row-labels {
  position: absolute;
  top: 0;
  left:82px;
  display: grid;
  grid-template-rows: repeat(var(--rows), var(--cell-size));
  height: calc(var(--rows) * var(--cell-size));
  align-items: center;
  justify-items: center;
}
.row-label-wrapper {
  display: flex;
  align-items: center;
}
.row-connector {
  width: 20px;
  height: 2px;
  background: var(--muted);
  margin-right: 6px;
}
.r {
  width: 28px;
  height: 28px;
  border: 2px dotted var(--muted);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  background: #fff;
  color: var(--muted);
}

/* Column labels with connectors */
.bottom-labels {
  position: absolute;
  bottom: 35px;
  left: 120px;
  display: grid;
  grid-template-columns: repeat(var(--cols), var(--cell-size));
  justify-items: center;
  width: calc(var(--cols) * var(--cell-size));
}
.col-label-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.connector {
  width: 2px;
  height: 20px;
  background: var(--muted);
}
.col-label {
  width: 28px;
  height: 28px;
  border: 2px dotted var(--muted);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  background: #fff;
  color: var(--muted);
  margin-top: 4px;
}

/* Bottom measures */
.bottom-measures-small {
  position: absolute;
  bottom: -28px;
  left: 120px;
  display: grid;
  grid-template-columns: repeat(var(--cols), var(--cell-size));
  justify-items: center;
  width: calc(var(--cols) * var(--cell-size));
}
.measure-small {
  font-size: 11px;
}

/* Axis labels */
.top-axis {
  position: absolute;
  top: -64px;
  left: 120px;
  width: calc(var(--cols) * var(--cell-size));
  text-align: center;
  font-size: 13px;
  color: var(--muted);
}
.right-axis {
  position: absolute;
  top: 20px;
  right: -140px;
  transform: rotate(90deg);
  transform-origin: left top;
  font-size: 13px;
  color: var(--muted);
}

.m-input {
  border: 1px solid #bfc7d1;
  background: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 4px 6px;
  text-align: center;
  width: 50px;
}

.m-input.rotate {
  transform: rotate(-90deg);
}
.right-measures .m-input.rotate {
  transform: rotate(90deg);
}

`, "",{"version":3,"sources":["webpack://./src/Pages/smart_construction_app/Customer_V4/Estimate/BuildingGrid.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B,EAAE,qBAAqB;EACpD,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,4CAA4C;EAC5C,aAAa;EACb,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,4DAA4D;EAC5D,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,4CAA4C;EAC5C,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,aAAa;EACb,yDAAyD;EACzD,4CAA4C;EAC5C,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,4DAA4D;EAC5D,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,4DAA4D;EAC5D,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[":root {\n\n  --cell-size: 84px;\n  --accent: #222;\n  --muted: #9aa1ad;\n}\n\n.diagram {\n  position: relative;\n  padding: 36px 80px 90px 140px; /* space for labels */\n  width: calc(var(--cols) * var(--cell-size));\n  box-sizing: content-box;\n}\n\n/* Outer border */\n.frame {\n  border: 4px solid #1f2937;\n  width: calc(var(--cols) * var(--cell-size));\n  height: calc(var(--rows) * var(--cell-size));\n  display: grid;\n  grid-template-columns: repeat(var(--cols), 1fr);\n  grid-template-rows: repeat(var(--rows), 1fr);\n}\n\n.cell {\n  border-right: 1px dashed #bfc7d1;\n  border-bottom: 1px dashed #bfc7d1;\n}\n.cell:nth-child(6n) {\n  border-right: none;\n}\n.cell:nth-last-child(-n + 6) {\n  border-bottom: none;\n}\n\n/* Measurement boxes */\n.m,\n.measure-small {\n  border: 1px solid #bfc7d1;\n  background: #fff;\n  border-radius: 4px;\n  font-size: 12px;\n  padding: 4px 8px;\n  text-align: center;\n}\n\n/* Top measures */\n.top-measures {\n  position: absolute;\n  top: -28px;\n  left: 120px;\n  display: grid;\n  grid-template-columns: repeat(var(--cols), var(--cell-size));\n  justify-items: center;\n  width: calc(var(--cols) * var(--cell-size));\n}\n\n/* Left measures */\n.left-measures {\n  position: absolute;\n  top: 0;\n  left: -96px;\n  height: calc(var(--rows) * var(--cell-size));\n  display: grid;\n  grid-template-rows: repeat(var(--rows), var(--cell-size));\n  align-items: center;\n  justify-items: center;\n}\n.left-measures .m {\n  transform: rotate(-90deg);\n  width: 62px;\n}\n\n/* Right measures */\n.right-measures {\n  position: absolute;\n  top: 0;\n  right: -96px;\n  height: calc(var(--rows) * var(--cell-size));\n  display: grid;\n  grid-template-rows: repeat(var(--rows), var(--cell-size));\n  align-items: center;\n  justify-items: center;\n}\n.right-measures .m {\n  transform: rotate(90deg);\n  width: 62px;\n}\n\n/* Row labels with connectors */\n.row-labels {\n  position: absolute;\n  top: 0;\n  left:82px;\n  display: grid;\n  grid-template-rows: repeat(var(--rows), var(--cell-size));\n  height: calc(var(--rows) * var(--cell-size));\n  align-items: center;\n  justify-items: center;\n}\n.row-label-wrapper {\n  display: flex;\n  align-items: center;\n}\n.row-connector {\n  width: 20px;\n  height: 2px;\n  background: var(--muted);\n  margin-right: 6px;\n}\n.r {\n  width: 28px;\n  height: 28px;\n  border: 2px dotted var(--muted);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  background: #fff;\n  color: var(--muted);\n}\n\n/* Column labels with connectors */\n.bottom-labels {\n  position: absolute;\n  bottom: 35px;\n  left: 120px;\n  display: grid;\n  grid-template-columns: repeat(var(--cols), var(--cell-size));\n  justify-items: center;\n  width: calc(var(--cols) * var(--cell-size));\n}\n.col-label-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.connector {\n  width: 2px;\n  height: 20px;\n  background: var(--muted);\n}\n.col-label {\n  width: 28px;\n  height: 28px;\n  border: 2px dotted var(--muted);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  background: #fff;\n  color: var(--muted);\n  margin-top: 4px;\n}\n\n/* Bottom measures */\n.bottom-measures-small {\n  position: absolute;\n  bottom: -28px;\n  left: 120px;\n  display: grid;\n  grid-template-columns: repeat(var(--cols), var(--cell-size));\n  justify-items: center;\n  width: calc(var(--cols) * var(--cell-size));\n}\n.measure-small {\n  font-size: 11px;\n}\n\n/* Axis labels */\n.top-axis {\n  position: absolute;\n  top: -64px;\n  left: 120px;\n  width: calc(var(--cols) * var(--cell-size));\n  text-align: center;\n  font-size: 13px;\n  color: var(--muted);\n}\n.right-axis {\n  position: absolute;\n  top: 20px;\n  right: -140px;\n  transform: rotate(90deg);\n  transform-origin: left top;\n  font-size: 13px;\n  color: var(--muted);\n}\n\n.m-input {\n  border: 1px solid #bfc7d1;\n  background: #fff;\n  border-radius: 4px;\n  font-size: 12px;\n  padding: 4px 6px;\n  text-align: center;\n  width: 50px;\n}\n\n.m-input.rotate {\n  transform: rotate(-90deg);\n}\n.right-measures .m-input.rotate {\n  transform: rotate(90deg);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
